export const EXPIRING_WINDOW_DAYS = 90;
export const APPROVAL_LEAD_DAYS = 30;
export const APPROVAL_ALERT_DAYS = 15;
export const TAKEN_RECENT_DAYS = 30;
